import React, { FC } from 'react'
import { Box, Typography } from '@mui/material'

type Props = {
  noDataText: string
  alignment: 'left' | 'right' | 'center'
  margin?: number | string
}

const NoDataComponent: FC<Props> = (props) => {
  return (
    <Box sx={{
      flex: '0 0 auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: (props.alignment === 'left' && 'flex-start') || (props.alignment === 'right' && 'flex-end') || 'center',
      justifyContent: 'center',
      height: '100%',
      width: '100%',
      margin: props.margin || 'inherit',
    }}
    >
      <Typography variant='body1'>{props.noDataText}</Typography>
    </Box>
  )
}

export default NoDataComponent
